const messages = {
  name: 'Aplicacion |||| Aplicaciones',
  fields: {
    name: 'Nombre de Aplicacion',
  },
  empty: 'No hay aplicaciones todavia',
  invite: 'Anade tu primera aplicacion',
  create: {
    title: 'Crear Aplicacion',
  },
  edit: {
    title: 'Editar Aplicacion',
  },
  dialog: {
    title: 'Detalles de Aplicacion',
  },
  sections: {
    basicInfo: 'Informacion Basica',
  },
  columns: {
    actions: 'Acciones',
  },
  filters: {
    applicationName: 'Nombre de Aplicacion',
  },
  actions: {
    addApplication: 'Anadir Aplicacion',
    discard: 'Descartar',
    submit: 'Enviar',
  },
  validation: {
    nameRequired: 'El nombre de la aplicacion es obligatorio',
    nameMaxLength: 'El nombre debe tener como maximo %{max} caracteres',
  },
  help: {
    createBanner: 'Anade una nueva aplicacion a tu cuenta de Notify.',
    editBanner: 'Actualiza los detalles de la aplicacion.',
    name: 'El nombre de la aplicacion. Debe ser unico.',
  },
  delete: {
    title: 'Eliminar aplicacion "%{recordName}"',
    content: 'Seguro que quieres eliminar esta aplicacion? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Aplicacion creada correctamente',
    updated: 'Aplicacion actualizada correctamente',
    deleted: 'Aplicacion eliminada correctamente',
    loadFailed: 'Error al cargar la aplicacion',
    createFailed: 'Error al crear la aplicacion',
    updateFailed: 'Error al actualizar la aplicacion',
  },
};

export default messages;
